import 'lazysizes'
import 'bootstrap/dist/css/bootstrap-reboot.min.css'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
require("prismjs/themes/prism-okaidia.css")
require("bootstrap")
require('animate.css')